import { config } from 'zod'
import { de } from 'zod/locales'

config(de())
